import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import ApiOffice from "../../gd/api/office";
import ModelProxy from "../model-proxy";
import ErrorProto from "../../gd/validation/error";
import ErrorFieldRequired from "../../gd/validation/error-field-required";

const debug = "Office"
// const debug = false

export default class Office extends ModelEntity {

    public companyId: ID
    public name        : string
    public ipAddresses : string
    public isDeleted   : string
    // public sortPosition: string


    constructor(data: any, useProxy = true) {

        super(data['id'], EntityType.OFFICE);

        this.companyId      = data['companyId']
        this.name           = data['name']
        this.isDeleted      = data['isDeleted']
        this.sortPosition   = data['sortPosition']

        this.ipAddresses    = data['ipAddresses']

        // templ path arr of ips -> string
        if (_.isArray(this.ipAddresses)) {
            // @ts-ignore
            this.ipAddresses = this.ipAddresses.join("\n")
        }
        // end temp patch


        return useProxy ? new Proxy(this, ModelProxy) : this;

    }

    // No id = new ver saved = new model
    get isNewModel():boolean {
        return !this.id
    }

    get isExistingModel():boolean {
        return !!this.id
    }

    get ipAddressesAsArray():string[] {
        return this.ipAddresses?.split('\n') || []
    }

    async save():Promise<boolean> {

        const payload: any = {}

        debug && console.log(debug,"save", this.updatedFields);

        // if new model -> create instead of save
        if (this.isNewModel) {
            await ApiOffice.createV2(this.toJSON()).promise()
            return true
        }

        // Update
        // this is for universal update
        this.updatedFields.forEach((fieldName) => {
            switch (fieldName) {

                case 'ipAddresses':
                    payload['ipAddresses'] = this.ipAddressesAsArray
                    break

                default                 :
                    // @ts-ignore
                    payload[fieldName] = this[fieldName]
            }
        })

        this.updatedFields.clear()

        if (_.size(payload)>0) {
            await ApiOffice.updateV2(this.id, payload).promise()
            return true
        }

        return false
    }

    toOption():Option {
        return {
            label       : this.name,
            value       : this.id
        }
    }

    validate():ErrorProto[] | null  {
        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.office.name))

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJSON() {
        return {
            id              : this.id,
            companyId       : this.companyId,
            name            : this.name,
            ipAddresses     : this.ipAddressesAsArray,
            isDeleted       : this.isDeleted,
            sortPosition    : this.sortPosition,
        }
    }

}
